import axios from "axios";
import authHeader from "./auth-header";
import apihostname from "./apihostname";

const instance = axios.create({
  baseURL: apihostname,
  headers: authHeader(),
});
// const head = { "Content-Type": "multipart/form-data" };

// const instance2 = axios.create({
//   baseURL: "http://localhost:3333",
//   headers: { ...authHeader(), ...head },
// });
class TimeregService {
  // newPass(id, req) {
  //   return instance.put("/users/new", req, {
  //     params: {
  //       id: id,
  //     },
  //   });
  // }
  //   updateUserprofile(id, req) {
  //     return instance.put("/users/profile/" + id, req);
  //   }
  //   getUserprofile(id) {
  //     return instance.get("/users/profile/" + id);
  //   }
  deleteTimereg(id) {
    return instance.delete("/timereg/" + id);
  }
  getTimereg(id) {
    return instance.get("/timereg/" + id);
  }
  updateTimereg(id, body) {
    return instance.put("/timereg/" + id, body);
  }
  getTimeRegAll() {
    return instance.get("/timeregall/");
  }
  getTimereglist(user_reg) {
    return instance.get("/timereglist/" + user_reg);
  }
  createTimereg(userid, body) {
    return instance.post("/timereg/new", body, {
      user: {
        user_id: userid,
      },
    });
  }
  getCurrent() {
    return instance.get("/current_timereg");
  }
  getLastCurrent() {
    return instance.get("/last_timereg");
  }
  getLastCurrentTemp() {
    return instance.get("/last_timereg_temp");
  }
}

export default new TimeregService();
